// src/redux/services/locationService.js
import API_CONSTANTS from '@/utils/apiConstants';
import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from './customBaseQuery';

// Ensure the baseUrl doesn't have a trailing slash
const baseUrl = process.env.NEXT_PUBLIC_API_URL.replace(/\/+$/, '');

export const locationApi = createApi({
  reducerPath: 'locationApi',
  baseQuery: customBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getCountries: builder.query({
      query: () => ({
        url: `${API_CONSTANTS.GET_COUNTRIES}`,
        method: 'GET',
      }),
    }),
    getStates: builder.query({
      query: ({ countryId }) => {
        if (!countryId) {
          return {
            url: `${API_CONSTANTS.GET_STATES}`.replace('/:id', ''),
            method: 'GET',
          };
        }
        return {
          url: `${API_CONSTANTS.GET_STATES.replace(':id', countryId)}`,
          method: 'GET',
        };
      },
    }),
    getCities: builder.query({
      query: ({ stateId }) => {
        if (!stateId) {
          return {
            url: `${API_CONSTANTS.GET_CITIES}`.replace('/:id', ''),
            method: 'GET',
          };
        }
        return {
          url: `${API_CONSTANTS.GET_CITIES.replace(':id', stateId)}`,
          method: 'GET',
        };
      },
    }),
    getSalesAreas: builder.query({
      query: (params = {}) => {
        const { cityIds, cityId, ...otherParams } = params;
        const ids = cityIds || cityId;

        if (ids) {
          const url = `${API_CONSTANTS.GET_SALES_AREAS.replace(':id', ids)}`;
          return {
            url,
            method: 'GET',
            params: otherParams,
          };
        }
        return {
          url: `${API_CONSTANTS.GET_SALES_AREAS.replace('/:id', '')}`,
          method: 'GET',
          params: otherParams,
        };
      },
    }),
  }),
});

export const { useGetCountriesQuery, useGetStatesQuery, useGetCitiesQuery, useLazyGetStatesQuery, useLazyGetCitiesQuery, useGetSalesAreasQuery, useLazyGetSalesAreasQuery } = locationApi;
